//Reset data
export const RESET = "INSTITUTIONTYPE_CREATE_RESET"

//Loading
export const SET_TOGGLE_LOADING = "INSTITUTIONTYPE_CREATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "INSTITUTIONTYPE_CREATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "INSTITUTIONTYPE_CREATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "INSTITUTIONTYPE_CREATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "INSTITUTIONTYPE_CREATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "INSTITUTIONTYPE_CREATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "INSTITUTIONTYPE_CREATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "INSTITUTIONTYPE_CREATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "INSTITUTIONTYPE_CREATE_SET_HIDE_MESSAGE"

//Data
export const SET_CREATED = "INSTITUTIONTYPE_CREATE_SET_CREATED"
export const SET_IS_CREATED = "INSTITUTIONTYPE_CREATE_SET_IS_CREATED"
export const SET_NOT_CREATED = "INSTITUTIONTYPE_CREATE_SET_NOT_CREATED"
export const SET_CURRENT_ITEM = "INSTITUTIONTYPE_CREATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "INSTITUTIONTYPE_CREATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "INSTITUTIONTYPE_CREATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "INSTITUTIONTYPE_CREATE_SET_HIDE_MODAL"


export const SET_MODAL = "INSTITUTIONTYPE_CREATE_SET_MODAL"
export const SET_MODAL_CONTENT = "INSTITUTIONTYPE_CREATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "INSTITUTIONTYPE_CREATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "INSTITUTIONTYPE_CREATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "INSTITUTIONTYPE_CREATE_SET_MODAL_TYPE"